import { Card } from "@mui/material";
import {
  CartesianGrid,
  ComposedChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

import { COLORS } from '../../ui/Theme'

const ChartContainer = ({ children, data, title }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        p: 3,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        zIndex: -1,
      }}
    >
      <h3 style={{ textAlign: "center" }}>{title}</h3>
      <ResponsiveContainer width="100%" height={400}>
        <ComposedChart data={data}>
          <Tooltip
            formatter={(value) => new Intl.NumberFormat("fa-IR").format(value)}
            contentStyle={{
              borderRadius: "5px",
            }}
            cursor={{ fill: COLORS.SOFTGRAY }}
          />
          <CartesianGrid stroke="transparent" strokeDasharray="5 5" />
          {children}
        </ComposedChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default ChartContainer;
